<template>
    <div v-if="isLoaded">
        <div class="content-body" v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <h4 class="card-title">Grade de Coleta e Entrega</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3" @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"  v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()" v-b-tooltip title="Cadastrar"><i class="ft-plus" v-if="getPermission('unidade.store')"></i></a></li>
                                    <li><a @click="onActivateDesactivate(1, null, false)" v-b-tooltip title="Ativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-up"></i></a></li>
                                    <li><a @click="onActivateDesactivate(2, null, false)" v-b-tooltip title="Inativar Registros" v-if="getPermission('unidade.status')"><i class="fa fa-thumbs-o-down"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Expande a tela" v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()" v-b-tooltip title="Minimiza a tela" v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()" v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData" text-fg-color="#ffffff" message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                            api-url="/api/gradecoletaentrega"
                                            :fields="fields"
                                            :css="css"
                                            :append-params="moreParams"
                                            track-by="gracolent_id"
                                            pagination-path=""
                                            @vuetable:pagination-data="onPaginationData"
                                            @vuetable:cell-clicked="onDetail"
                                            detail-row-component="unidade-detalhes"
                                            @vuetable:loaded="onLoaded"
                                          >
                                          <template slot="status" slot-scope="props">
                                              <span class="badge badge-success" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                              <span class="badge badge-danger" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                            </template>
                                          <template slot="grade_coleta" slot-scope="props">
                                              <span v-if="props.rowData.coleta_segunda.valor==1">Seg </span>
                                              <span v-if="props.rowData.coleta_terca.valor==1">Ter </span>
                                              <span v-if="props.rowData.coleta_quarta.valor==1">Qua </span>
                                              <span v-if="props.rowData.coleta_quinta.valor==1">Qui </span>
                                              <span v-if="props.rowData.coleta_sexta.valor==1">Sex </span>
                                              <span v-if="props.rowData.coleta_sabado.valor==1">Sab </span>
                                              <span v-if="props.rowData.coleta_domingo.valor==1">Dom </span>
                                            </template>
                                          <template slot="grade_entrega" slot-scope="props">
                                              <span v-if="props.rowData.entrega_segunda.valor==1">Seg </span>
                                              <span v-if="props.rowData.entrega_terca.valor==1">Ter </span>
                                              <span v-if="props.rowData.entrega_quarta.valor==1">Qua </span>
                                              <span v-if="props.rowData.entrega_quinta.valor==1">Qui </span>
                                              <span v-if="props.rowData.entrega_sexta.valor==1">Sex </span>
                                              <span v-if="props.rowData.entrega_sabado.valor==1">Sab </span>
                                              <span v-if="props.rowData.entrega_domingo.valor==1">Dom </span>
                                            </template>
                                          <template slot="actions" slot-scope="props">
                                            <div class="custom-actions">
                                                <a @click="onEdit(props.rowData, props.rowIndex)" v-if="getPermission('unidade.update')" v-b-tooltip title="Editar"><i class="fa fa-edit"></i></a>
                                                <a v-if="props.rowData.status.valor==2" @click="onActivateDesactivate(1, props.rowData, true)" v-b-tooltip title="Ativar"><i class="fa fa-thumbs-o-up"></i></a>
                                                <a v-if="props.rowData.status.valor==1" @click="onActivateDesactivate(2, props.rowData, true)" v-b-tooltip title="Inativar"><i class="fa fa-thumbs-o-down"></i></a>
                                                <!-- <a @click="onDetail(props.rowData, null, null)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a> -->
                                            </div>
                                          </template>
                                      </vuetable>
                                  </div>
                                <div>
                                    <div class='col-md-12'>
                                        <div class="pull-left pagination-detail">
                                            <vuetable-pagination-info ref="paginationInfo"
                                                                      :css="css.pagination"
                                                                      info-class="pull-left"
                                            ></vuetable-pagination-info>
                                        </div>
                                        <div class="pull-right m-a-0">
                                            <vuetable-pagination ref="pagination"
                                                                 :css="css.pagination"
                                                                 @vuetable-pagination:change-page="onChangePage"
                                            ></vuetable-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <GradeDeEntregaForm ref="gradedeentregaform" />
    </div>
</div>
</template>
<script>
import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import GradeDeEntregaFilterBar from './GradeDeColetaEntregaFilterBar.vue'
import GradeDeEntregaForm from './GradeDeEntregaForm.vue'
import moment from 'moment'

// Vue.component('unidade-detalhes', UnidadeDetalhes);

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        GradeDeEntregaForm,
        'vuetable-filterbar': GradeDeEntregaFilterBar,
    },
    data () {
      return {
        date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalDoc: false,
        showModalConta: false,
        isFullscreen: false,
        optionsMunicipio:[],
        optionsStatus: [],
        optionsTpOperacao: [],
        optionsRegiao: [],
        helpForm: new Form({recordCollection: [], status:'', statusRecord: []}),
        fields: [
          {
            name: '__checkbox',
            titleClass: 'center aligned',
            dataClass: 'center aligned'
          },
          {
            name:  'municipio_ini.nome',
            title: 'Municipio Origem',
            sortField: 'municipio_ini'
          },
          {
            name:  'municipio_fim.nome',
            title: 'Municipio Destino',
            sortField: 'municipio_fim'
          },
          {
            name:  'regiao_ini.descr',
            title: 'Região Origem',
            sortField: 'regiao_ini'
          },
          {
            name: 'regiao_fim.descr',
            title: 'Região Destino',
            sortField: 'regiao_fim'
          },
          {
            name: '__slot:grade_coleta',
            title: 'Grade Coleta',
            sortField: 'grade_coleta'
          },
          {
            name: 'qtde_dias_coleta',
            title: 'Qtd de dias',
            sortField: 'qtde_dias_coleta'
          },
          {
            name: '__slot:grade_entrega',
            title: 'Grade entrega',
            sortField: 'grade_entrega'
          },
          {
            name: 'qtde_dias_entrega',
            title: 'Qtd de dias',
            sortField: 'qtde_dias_entrega'
          },
          {
            name: 'tp_operacao.descr',
            title: 'Tipo de Operação',
            sortField: 'tp_operacao'
          },
          {
            name: 'pessoa.pessoa_juridica.razao_social',
            title: 'Transportadora',
            sortField: 'transportadora'
          },
          {
            name: '__slot:status',
            title: 'Status',
            sortField: 'status'
          },
          {
              name: '__slot:actions',   // <----
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
        ],
        css: {
            tableClass: 'table table-striped',
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        moreParams: {}
       }

    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
        this.$events.$on('filter-reset', e => this.onFilterReset());
        this.getLivGeral();
      },
    created() {
        let self = this;
        Event.$on('reloadVuetable', function (data) {
            self.onReloadVuetable();
        });

    },
    methods: {
        onPaginationData (paginationData) {
          this.$refs.pagination.setPaginationData(paginationData)
          this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onChangePage (page) {
          this.$refs.vuetable.changePage(page)
        },
        onFilterSet (data_filter) {
            this.loadingData = true;
            this.moreParams = {
                'municipio_ini': data_filter.municipio_ini.value,
                'municipio_fim': data_filter.municipio_fim.value,
                'regiao_ini': data_filter.regiao_ini.value,
                'regiao_fim': data_filter.regiao_fim.value,
                'tp_operacao': data_filter.tp_operacao.value,
                'status': data_filter.status.value,
                'transportadora': data_filter.transportadora.value,
            }
            Vue.nextTick( () => this.$refs.vuetable.reload())
        },
        onFilterReset () {
            this.loadingData = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterShowHide() {
            if(this.vuetableFilterRow)
            {
                this.$store.commit('setVuetableFilterRow', false);
            }
            else
            {
                this.$store.commit('setVuetableFilterRow', true);
            }
        },
        onLoaded: function () {
            this.dataExport = this.$refs.vuetable.tableData;
            this.loadingData = false;
            this.$store.commit('setVuetableFilterButton', false);
        },
        onDetail (data, field, event) {
            this.$refs.vuetable.toggleDetailRow(data.unidade_id);
        },
        formatDate (value, fmt = 'D MMM YYYY') {
          return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD').format(fmt)
        },
        DateFormat: function(date) {
          if(date != null){
          return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
          return "";
        },
        handleOk(e)
        {
            e.preventDefault();
            if(this.modal_acao=="i")
            {
               this.onStore();
            }
            else
            {
                this.onUpdate(this.form.unidade_id);
            }
        },
        onCreate () {
            this.$refs.gradedeentregaform.onCreate();
        },
        onEdit (data, index) {
            this.$refs.gradedeentregaform.onEdit(data);
        },
        onReloadVuetable() {
            this.$refs.vuetable.reload();
        },
        getLivGeral() {
            this.helpForm.get('/api/gradecoletaentrega/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.municipio.forEach((obj)=>{
                    this.optionsMunicipio.push({
                        label: obj.nome + " - " + obj.uf.cd, value: obj.municipio_id
                    })
                })
                response.status.forEach((obj)=>{
                    this.optionsStatus.push({
                        label:obj.descr, value:obj.valor
                    })
                })
                response.regiao.forEach((obj)=>{
                    this.optionsRegiao.push({
                        label: obj.descr, value: obj.regiao_id
                    })
                })
                response.tp_operacao.forEach((obj)=>{
                    this.optionsTpOperacao.push({
                        label:obj.descr, value:obj.valor
                    })
                })
                
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
            return (value == null || value == "")
              ? ''
              : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
        },
        expandFullscreen() {
            this.isFullscreen = !this.isFullscreen;
        },
        onActivateDesactivate(action, data, tipo) {
            // Tipo = true = Checkbox
            this.helpForm.status = action;
            if(tipo)
            {
                this.helpForm.statusRecord = [];
                this.helpForm.statusRecord.push(data.gracolent_id);
            }
            else
            {
                this.helpForm.statusRecord = [];
                this.$refs.vuetable.selectedTo.forEach((obj)=>{
                    this.helpForm.statusRecord.push(obj)
                });
            }
            this.$refs.gradedeentregaform.onActivateDesactivate(this.helpForm);
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        getPermission(checkPermission) {
            return this.getPermissionFw(checkPermission);
        },
    },
    computed: {
        vuetableFilterRow: {
            get () {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        user: {
            get() {
                return this.$store.state.logged.user;
            }
        },
        b_plano: {
            get() {
                return this.$store.getters.bplano;
            }
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        }
    }
}
</script>
<style>
    .form-check{
        padding: 0 1.25rem;
    }
</style>
